<dt [id]="id()" class="sh-description-list__term" style="width: 10rem" (mouseenter)="hoverFaceFrame()" (mouseleave)="unhoverFaceFrame()">
    <i>{{ label() }}</i>
    @if (face().Person?.AiLinked) {
        <div [title]="'profile-form.ai-generated-value' | translate" style="display: inline-block; margin-left: 0.25rem">
            <svg sh-icon [size]="'small'" [name]="'magic'" style="margin-bottom: 0.2rem"></svg>
        </div>
    }
</dt>
<dd class="sh-description-list__details" style="height: 2.5rem; width: 100%">
    @if (!(face().Person | isPerson)) {
        <div class="sh-input-field-with-action">
            <div class="sh-input-field-with-action__input">
                <ng-container *ngTemplateOutlet="inputField"></ng-container>
            </div>

            <sh-action-item
                class="sh-input-field-with-action__action"
                style="height: stretch; margin-top: 0.25rem"
                [item]="deleteActionItem"
                (mouseenter)="hoverFaceFrame()"
                (mouseleave)="unhoverFaceFrame()"
            ></sh-action-item>
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="faceTag"></ng-container>
    }
</dd>

<ng-template #inputField>
    <sh-live-options-select
        #childControl
        [id]="$faceId()"
        [placeholderMsg]="'facial-recognition.select-person' | translate"
        [searchPlaceholderMsg]="'facial-recognition.search-placeholder' | translate"
        [search]="true"
        [noResultsActionMsg]="'facial-recognition.create-person' | translate"
        [alwaysShowNoResultsAction]="true"
        [showMoreMsg]="'ui.load-more' | translate"
        [resultsPerPage]="25"
        [paginatedResultsFct]="paginatedResultsFct"
        [valueToLabelFct]="valueToLabelFct"
        [formGroupStyling]="[FormGroupStyling.NO_MARGIN]"
        (selectionState)="linkPerson($event)"
        (noResultsActionTrigger)="createPerson($event)"
        (focusin)="focusFaceFrame()"
        (focusout)="unfocusFaceFrame()"
        (mouseenter)="hoverFaceFrame()"
        (mouseleave)="unhoverFaceFrame()"
    >
    </sh-live-options-select>
</ng-template>

<ng-template #faceTag>
    <sh-face-tag [face]="face()" [editable]="true" [disabled]="false" (personRemoved)="unlinkPerson()" (nameChange)="changePersonName($event)"></sh-face-tag>
</ng-template>
